import React, { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import BreadCrumb from '../../lib/designSystem/BreadCrumb';
import EnhancedTab from '../../lib/designSystem/TabSimulation';
import Accounts from './Components/Accounts';
import Summary from './Components/Summary';

const tabs = [
  {
    label: 'Resumen',
    component: <Summary />,
    path: 'summary',
    index: 0,
  },
  {
    label: 'Cuentas',
    component: <Accounts />,
    path: 'accounts',
    index: 1,
  },
];

const Funds = () => {
  const navigate = useNavigate();
  const { page } = useParams<{ page: string }>();

  const startValue = useMemo(() => {
    return tabs.findIndex((x) => x.path === page) || 0;
  }, [page]);

  const handleNavigation = (index: number) => {
    navigate(`/funds/${tabs[index].path}`);
  };

  return (
    <>
      <BreadCrumb links={[{ title: 'Fondos', link: '/funds/accounts' }]} />
      <EnhancedTab
        startValue={startValue}
        tabs={tabs}
        onTabChange={handleNavigation}
      />
    </>
  );
};

export default Funds;
